import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { DlcoSessionListScreen } from "./DlcoSessionListScreen";
import { DlcoAnalysisScreen } from "./DlcoAnalysisScreen";
import { DlcoAnalysisListScreen } from "./DlcoAnalysisListScreen";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { SearchParams } from "../../Components/Query";

export const DlcoRoot = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <Routes>
            <Route index element={
               <PrivateRoute permissions={[PermissionEnum.AccessSingleDlcoSession, PermissionEnum.AccessAllDlcoSessions, PermissionEnum.OverreadDlcoSession]}>
                <DlcoSessionListScreen />
                </PrivateRoute>
            }
            />
            <Route path="Analysis" element={
               <PrivateRoute permissions={[PermissionEnum.OverreadDlcoSession]}>
                <DlcoAnalysisListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
                </PrivateRoute>
            }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadDlcoSession, PermissionEnum.AccessSingleDlcoSession]}>
                <DlcoAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
